<template>
    <div>
        <div class="row">
            <div class="col-6">
                <h2 class="step">Step {{ currentStep }} of 3</h2>
            </div>
            <div class="col-6 text-right pt-3">
                <a href="javascript:void(0);" @click="skip">Skip</a>
            </div>
        </div>

        <onboarding-course-types-component v-if="currentStep == 1"></onboarding-course-types-component>
        <onboarding-genres-component v-if="currentStep == 2"></onboarding-genres-component>
        <onboarding-goals-component v-if="currentStep == 3"></onboarding-goals-component>
        <!--<onboarding-found-options-component v-if="currentStep == 4"></onboarding-found-options-component>-->

        <div class="mt-5" v-if="currentStep > 1">
            <a href="javascript:void(0);" @click="prev">Go back</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            step: {
                type: Number,
                default: 1
            },
        },

        data() {
            return {
                currentStep: 1,
            }
        },

        mounted() {
            this.currentStep = this.step;

            Bus.$on("stepComplete", (d) => {
                if(d.step === 'goals') {
                    this.endRedirect();
                } else {
                    this.currentStep = this.currentStep + 1;
                }
            });
        },

        methods: {
            // Skip
            skip() {
                if(this.currentStep >= 3) {
                    this.endRedirect();
                } else {
                    this.currentStep = this.currentStep + 1;
                }
            },

            // Prev
            prev() {
                this.currentStep = this.currentStep - 1;
            },

            // End redirect
            endRedirect() {
                location.href = '/dashboard';
            },
        }
    }
</script>
